import { render, staticRenderFns } from "./FieldFloat.vue?vue&type=template&id=58311e90&scoped=true"
import script from "./FieldFloat.vue?vue&type=script&lang=js"
export * from "./FieldFloat.vue?vue&type=script&lang=js"
import style0 from "./FieldFloat.vue?vue&type=style&index=0&id=58311e90&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58311e90",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
